import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import BaseMaterialAsyncSelect from './BaseMaterialAsyncSelect'

// http://adazzle.github.io/react-data-grid/docs/examples/custom-editors

export default class MaterialEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value
    }
  }

  static propTypes = {
    value: PropTypes.object,
    column: PropTypes.object.isRequired,
    onCommit: PropTypes.func.isRequired,
    onCommitCancel: PropTypes.func.isRequired,
    rowData: PropTypes.object.isRequired,
    rowIdx: PropTypes.object,
  }

  getValue() {
    return { [this.props.column.key]: this.state.value }
  }

  getInputNode() {
    // eslint-disable-next-line react/no-find-dom-node
    return ReactDOM.findDOMNode(this).getElementsByTagName('input')[0]
  }

  disableContainerStyles() {
    return true
  }

  handleChangeMaterial = val => {
    this.setState({value: val}, () => this.props.onCommit())
  }

  render() {
    return (
      <BaseMaterialAsyncSelect
        value={this.state.value}
        onChange={this.handleChangeMaterial}
      />
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/Welds/helpers/MaterialEditor.js